var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 2.16406C3.332 2.16406 1 4.46226 1 7.28869V14.3844C1 17.2107 3.332 19.5089 6.2 19.5089H13.4C16.268 19.5089 18.6 17.2107 18.6 14.3844V7.28869C18.6 4.46226 16.268 2.16406 13.4 2.16406H6.2ZM14.6 5.31768C15.04 5.31768 15.4 5.67246 15.4 6.10609C15.4 6.53971 15.04 6.89449 14.6 6.89449C14.16 6.89449 13.8 6.53971 13.8 6.10609C13.8 5.67246 14.16 5.31768 14.6 5.31768ZM9.8 6.50029C12.228 6.50029 14.2 8.44371 14.2 10.8365C14.2 13.2294 12.228 15.1728 9.8 15.1728C7.372 15.1728 5.4 13.2294 5.4 10.8365C5.4 8.44371 7.372 6.50029 9.8 6.50029ZM9.8 7.28869C7.816 7.28869 6.2 8.88127 6.2 10.8365C6.2 12.7918 7.816 14.3844 9.8 14.3844C11.784 14.3844 13.4 12.7918 13.4 10.8365C13.4 8.88127 11.784 7.28869 9.8 7.28869Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBlack);
export default __webpack_public_path__ + "static/media/instagram-black.2b477a32b13dca75c51d103ebd4b1b90.svg";
export { ForwardRef as ReactComponent };